<template>
    <div class="col-md-6">
        <BaseBoxSection :helpName="helpName" :title="__('remarks')">
            <div :class="{'has-error': hasError('remarks')}" class="col-md-12">
                <textarea
                    :disabled="disabled"
                    :value="value"
                    class="form-control"
                    style="height:173px;"
                    @change="$emit('input', $event.target.value)"
                ></textarea>

                <InputErrors :errors="getErrors('remarks')"/>
            </div>
        </BaseBoxSection>
    </div>
</template>

<script>
import BaseBoxSection from "../BaseBoxSection";
import hasErrors from "../../mixins/hasErrors";
import InputErrors from "../form/InputErrors";
import hasRequiredFields from "../../mixins/hasRequiredFields";

export default {
    name: "RemarksBox",
    mixins: [hasErrors, hasRequiredFields],
    components: {InputErrors, BaseBoxSection},
    props: {
        value: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        helpName: {
            type: String,
            required: true,
        },
    },
};
</script>
